import { Api } from '../api';
import { content } from '../endpoints';
import type { DecoderResponse, GetContactResponse, GetFeedResponse, GetServicesResponse, TariffJsonResponse } from './models';

export class ContentApi extends Api {
  static getFeed = (top: number, signal?: AbortSignal) => this.get<GetFeedResponse[]>({ url: content.feed(top), signal: signal });

  static getServices = (signal?: AbortSignal) => this.get<GetServicesResponse[]>({ url: content.services(), signal: signal });

  static getContact = (signal?: AbortSignal) => this.get<GetContactResponse>({ url: content.contact(), signal: signal });

  static getTariff = (signal?: AbortSignal) => this.get<string>({ url: content.tariff(), signal: signal });

  static getTariffJson = (signal?: AbortSignal) => this.get<TariffJsonResponse>({ url: content.tariffJson(), signal: signal });

  static getSiteTC = (signal?: AbortSignal) => this.get<DecoderResponse>({ url: content.siteTC(), signal: signal });

  static getCardTC = (signal?: AbortSignal) => this.get<DecoderResponse>({ url: content.cardsTC(), responseType: 'arraybuffer', signal: signal });

  static getCookies = (signal?: AbortSignal) => this.get<DecoderResponse>({ url: content.cookies(), signal: signal });

  static getPrivacy = (signal?: AbortSignal) => this.get<DecoderResponse>({ url: content.privacy(), signal: signal });
}
